import type { TransientCard } from '@models';
import jwtDecode from 'jwt-decode';

type TransientTokenContent = {
  paymentInformation?: {
    card?: {
      number?: { maskedValue?: string; detectedCardTypes?: string[] };
    };
  };
};

/**
 * RCP-466 — the card the player entered, read from the Cybersource transient token (a JWT whose
 * `content` claim carries `paymentInformation.card.number`). Microform never exposes the number
 * itself, but the token's masked value is what the backend decodes for the order, so the review
 * shows the same last digits. Display only: the signature is not verified, and anything
 * unreadable yields `null`.
 */
export const decodeTransientCard = (token: string): TransientCard | null => {
  try {
    const claim = jwtDecode<{ content?: TransientTokenContent | string }>(token).content;
    const content: TransientTokenContent | undefined = typeof claim === 'string' ? JSON.parse(claim) : claim;
    const number = content?.paymentInformation?.card?.number;
    const lastFourDigits = number?.maskedValue?.slice(-4);
    if (!lastFourDigits || !/^\d{4}$/.test(lastFourDigits)) return null;

    return { lastFourDigits, cardType: number?.detectedCardTypes?.[0]?.toLowerCase() ?? '' };
  } catch {
    return null;
  }
};
